export default __webpack_public_path__ + "static/logo-33ce41b1017a7fccbdee5efaf409de5c.png";